import { cn } from '@rocco/utils/cn';
import { DIRECTORY_GUTTER_X } from './EditorialArticleGrid';

interface EditorialEmptyResultsProps {
    /** Clears every applied facet, returning to the whole category. */
    onClearFilters: () => void;
    className?: string;
}

/**
 * What the grid shows when the applied facets match nothing.
 *
 * The facets carry no counts — the listing is served by the CMS category query
 * rather than an aggregating search index — so a reader can always stack them
 * into an empty set. This is the way out of that: it says what happened and
 * offers the one action that undoes it, rather than leaving a blank column.
 */
export const EditorialEmptyResults = ({
    onClearFilters,
    className,
}: EditorialEmptyResultsProps) => (
    <div
        className={cn(
            'flex flex-col items-start px-[1.5rem]',
            DIRECTORY_GUTTER_X,
            className,
        )}
        data-testid="editorial-empty-results"
    >
        <p className="m-0 font-gestura text-[2rem] leading-[1.1] text-[#141414]">
            Nothing matches those filters
        </p>
        <p className="mt-[0.75rem] mb-0 text-[1rem] leading-[1.5] text-[#575757]">
            Try widening one of them, or start again with the whole category.
        </p>
        <button
            type="button"
            onClick={onClearFilters}
            className="mt-[1.5rem] h-10.5 shrink-0 rounded-[var(--radius-btn-m)] bg-[#323232] px-6 text-[1rem] text-white transition-colors hover:bg-[#141414]"
        >
            Clear filters
        </button>
    </div>
);
